module.exports = __webpack_public_path__ + "static/media/pause-icon.689db19e.svg";